<div class="footer-links">
  <div class="footer-links__title">
    {{ 'FOOTER.' + label | translate }}
  </div>
  <ul>
    <li class="footer-links--single" *ngFor="let item of links">
      <ng-container
        *ngIf="
          !isActive('helpukraine') &&
          !isActive('how-to-help-ukraine') &&
          !isActive('help-ukraine') &&
          !header.eventCategory
        "
      >
        <a
          [routerLink]="'/' + item"
          *ngIf="
            item !== 'contact_us' &&
            label !== 'contact' &&
            item !== 'enquiries' &&
            item !== 'helpukraine-faq' &&
            item !== 'about-help-ukraine'
          "
        >
          {{ 'FOOTER.links.' + item | translate }}
        </a>
      </ng-container>
      <ng-container
        *ngIf="
          (isActive('helpukraine') ||
            isActive('how-to-help-ukraine') ||
            isActive('help-ukraine') ||
            header.eventCategory) &&
          (item === 'articles/how-it-works' ||
            item === 'articles/common/help-ukraine' ||
            item === 'helpukraine-faq' ||
            item === 'about-help-ukraine')
        "
      >
        <a
          [routerLink]="
            item === 'articles/how-it-works' ? '/articles/how-to-help-ukraine' : '/' + item
          "
          *ngIf="item !== 'contact_us' && label !== 'contact' && item !== 'enquiries'"
        >
          {{ 'FOOTER.links.' + item | translate }}
        </a>
      </ng-container>

      <a [href]="mailMe(item)" *ngIf="label === 'contact'">{{
        'FOOTER.links.' + item | translate
      }}</a>
      <div *ngIf="item === 'contact_us'">
        <button class="btn btn--link btn--contact" (click)="openModal('email-send')">
          {{ 'FOOTER.links.contact_us' | translate }}
        </button>
      </div>
      <div
        *ngIf="
          item === 'enquiries' &&
          !isActive('helpukraine') &&
          !isActive('how-to-help-ukraine') &&
          !isActive('help-ukraine') &&
          !header.eventCategory
        "
      >
        <button class="btn btn--link btn--contact" (click)="openModal('press-email-send')">
          {{ 'FOOTER.links.enquiries' | translate }}
        </button>
      </div>
    </li>
  </ul>
</div>

<p-dialog
  *ngIf="displayPressModal"
  [(visible)]="displayPressModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayPressModal = false"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <app-press-form (closeModalEmitter)="displayPressModal = false"></app-press-form>
  </div>
</p-dialog>

<p-dialog
  *ngIf="displayContactModal"
  [(visible)]="displayContactModal"
  [dismissableMask]="true"
  [modal]="true"
  (onHide)="displayContactModal = false"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <app-contact-form (closeModalEmitter)="displayContactModal = false"></app-contact-form>
  </div>
</p-dialog>
